import { Box, Typography } from "@mui/material";
import { brandContainer, ilwuLogo } from "./style";


export const DOAIconComp = () => {
  return (
    <Box sx={brandContainer}>
      <Typography component={"img"}
        src="assets/images/ilwu500logo_small.jpg"
        alt="ILWU"
        sx={ilwuLogo}
        data-automation="logo-ilwu"
      />
      <Typography component={"img"}
        src="assets/images/bcmea_icons/BCMEA_Tertiary_RGB_Colour.svg"
        alt="BCMEA"
        sx={{ width: '120px;', height: '55px' }}
        data-automation="logo-bcmea"
      />
    </Box>
  )
};